module.exports = __webpack_public_path__ + "img/2013-1.9e02944c.jpg";